// extracted by mini-css-extract-plugin
export var green = "points-list-module--green--e1433";
export var list = "points-list-module--list--425f3";
export var listItem = "points-list-module--list-item--a9b5b";
export var red = "points-list-module--red--81c51";